import React from 'react';
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { EVOLUTION_THEME, evolutionIdentificationPaperSxFor } from './evolutionTheme';

export type EvolutionIdentificationLayout = 'panel' | 'standalone';

interface EvolutionAttendanceIdentificationSectionProps {
  layout: EvolutionIdentificationLayout;
  patientField?: React.ReactNode;
  professionalField?: React.ReactNode;
  diagnosisField: React.ReactNode;
  cidField: React.ReactNode;
  compact?: boolean;
}

/**
 * Paciente + profissional + diagnóstico/CID em faixa compacta (sem accordion).
 * No painel do paciente o paciente já está definido — só profissional e diagnóstico.
 */
const EvolutionAttendanceIdentificationSection: React.FC<EvolutionAttendanceIdentificationSectionProps> = ({
  layout,
  patientField,
  professionalField,
  diagnosisField,
  cidField,
  compact = false,
}) => {
  const isPanel = layout === 'panel';
  const showProfessional = Boolean(professionalField);

  return (
    <Box component="section" aria-label="Identificação do atendimento" sx={evolutionIdentificationPaperSxFor(compact)}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: compact ? 0.35 : 0.75 }}>
        <Typography
          component="span"
          sx={{
            fontSize: '0.68rem',
            fontWeight: 700,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: EVOLUTION_THEME.sectionTitle,
          }}
        >
          Identificação do atendimento
        </Typography>
        <Tooltip
          title="Diagnóstico desta consulta. O diagnóstico principal do paciente fica na aba Diagnósticos do painel."
          placement="top"
          enterTouchDelay={0}
        >
          <IconButton size="small" aria-label="Sobre diagnóstico desta consulta" sx={{ p: 0.15, color: EVOLUTION_THEME.slate }}>
            <InfoOutlinedIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Grid container spacing={1} alignItems="flex-start">
        {!isPanel && patientField ? (
          <Grid item xs={12} sm={6}>
            {patientField}
          </Grid>
        ) : null}
        {showProfessional ? (
          <Grid item xs={12} sm={isPanel ? 4 : 6}>
            {professionalField}
          </Grid>
        ) : null}
        <Grid
          item
          xs={12}
          sm={
            isPanel
              ? showProfessional
                ? 5
                : 7
              : 7
          }
        >
          {diagnosisField}
        </Grid>
        <Grid
          item
          xs={12}
          sm={
            isPanel
              ? showProfessional
                ? 3
                : 5
              : 5
          }
        >
          {cidField}
        </Grid>
      </Grid>
    </Box>
  );
};

export default EvolutionAttendanceIdentificationSection;
